export const DRAWER_WIDTH = 240;

export const INITIAL_STATS = [
  { title: 'Toplam Sunucu', value: '0', color: '#1976d2' },
  { title: 'Aktif Sunucu', value: '0', color: '#2e7d32' },
  { title: 'Düşen Sunucu', value: '0', color: '#d32f2f' },
  { title: 'Çalışan sunucuların yüzdesi', value: '0%', color: '#ed6c02' },
];

export const HTTP_METHODS = [
  { value: 'GET', label: 'GET' },
  { value: 'POST', label: 'POST' },
  { value: 'PUT', label: 'PUT' },
  { value: 'DELETE', label: 'DELETE' },
  { value: 'PATCH', label: 'PATCH' },
  { value: 'HEAD', label: 'HEAD' },
];

export const INTERVAL_UNITS = [
  { value: 'seconds', label: 'Saniye' },
  { value: 'minutes', label: 'Dakika' },
  { value: 'hours', label: 'Saat' },
];

export const REPORT_TIME_UNITS = [
  { value: 'hours', label: 'Saat' },
  { value: 'days', label: 'Gün' },
  { value: 'weeks', label: 'Hafta' },
  { value: 'months', label: 'Ay' },
]; 